// extracted by mini-css-extract-plugin
export default {"list":"ExternalUser_list__eIFCY","label":"ExternalUser_label__FPn2P","name":"ExternalUser_name__RfMuW","action":"ExternalUser_action__eU8gr"};